import React from 'react';
import './PriceForecast.css';

// Import the new chart image
import forecastChart from '../../assets/images/price-forecast-chart.png';

const PriceForecast = () => {
  return (
    <section className="price-forecast-section">
      <div className="price-forecast-container">
        <div className="forecast-header-group">
          <div className="section-header">
            <h2>Market aligned price forecast</h2>
            <div className="header-line"></div>
          </div>
          <p className="section-subtitle">
            Our forecasts deliver ~98% price accuracy, helping you improve the overall operational efficiency of the business.
          </p>
        </div>

        <div className="forecast-content-grid">
          {/* Left Column: Image */}
          <div className="forecast-chart-col">
            <img src={forecastChart} alt="Price forecasting chart for HRC Exy-Mumbai" />
          </div>

          {/* Right Column: Text Content */}
          <div className="forecast-text-col">
            <h3>Built on 15+ years of CRISHI trusted data</h3>
            <p>
              Our deep historical repository of prices, data and trends gives us a clear view of market behavior, enabling sharper insights and better forecasting inputs.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PriceForecast;